<template>
  <div class="liu-xuan-test-result-img-2019">
    <div class="result-container">
      <div id="result-container"></div>
      <a class="action-btn"
         :href="info.url"
         v-ym-report:MARKETING_LIUXUAN_TEST_MORE_CLICK
      >
        <img :src="require('@/pages/2019/LiuXuanTest/assets/img/result/show_detail_btn.gif')"
             alt="">
      </a>
    </div>
    <div class="card"
         :class="{
          'qin-he': info.key === 'qhx',
          'wai-xian': info.key === 'wxx',
          'zi-jue': info.key === 'zjx',
          'qin-xu': info.key === 'qxx',
          'kai-fang': info.key === 'kfx',
         }"
         id="share-content-container"
         v-if="showContent"
    >
      <div class="content">
        <div class="header">
          <img :src="require('@/pages/2019/LiuXuanTest/assets/img/result/r_logo.png')"
               alt=""
          >
        </div>
        <div class="desc">每<span>100个</span>同龄人中，只有「<span class="num">{{ number }}</span>」个人</div>
        <div class="info">
          <div class="user-info">
            <div class="user">
              <span class="name">
                {{ name }}
                <span class="name-line"></span>
              </span>
              孩子性格
            </div>
            <div class="test-type">
              <img :src="info.type" alt="">
            </div>
            <div class="test-desc">
              <span>未来你的孩子会变得</span>
              <img :src="info.desc" alt="">
            </div>
          </div>
          <div class="totem">
            <img :src="info.totem" alt="">
          </div>
        </div>
        <div class="test-content">
          <span class="title">
            {{ content.title }}
            <span class="title-line"></span>
          </span>
          <div class="summary" v-html="content.content"></div>
        </div>
        <div class="test-hint" v-html="info.hint"></div>
        <div class="qr-code-block">
          <div class="save-hint">
            <div class="hint">
              <span>长按保存图片</span>
              <span>扫码|开启孩子性格</span>
            </div>
            <div class="course">刘轩给孩子的心理学课，教孩子比IQ更重要的事</div>
          </div>
          <img :src="require('@/pages/2019/LiuXuanTest/assets/img/result/qr_code.png')"
               alt=""
               class="qr-code"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { htmlToCanvas, canvasToImage } from '@/utils/canvas';

  export default {
    name: 'LiuXuanTestResultImg2019',
    props: {
      name: {
        type: String,
        required: true,
      },
      number: {
        type: Number,
        required: true,
      },
      info: {
        type: Object,
        required: true,
      },
      infoRandom: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        showContent: true,
      };
    },
    computed: {
      content() {
        return this.info.info[this.infoRandom];
      },
    },
    methods: {
      async generateImage() {
        const $certificate = document.getElementById('share-content-container');
        const $resultContainer = document.getElementById('result-container');
        const canvas = await htmlToCanvas($certificate);
        const img = canvasToImage(canvas);
        $resultContainer.appendChild(img);
        this.showContent = false;
      },
      handleHideImg() {
        this.$emit('hideImg');
      },
    },
    created() {
      this.$nextTick(() => {
        this.generateImage();
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .liu-xuan-test-result-img-2019 {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: @z-index-largest;
    background: @color-white;
    overflow-y: scroll;
  }
  .card {
    width: 750px;
    padding: 26px @size-base;
    box-sizing: border-box;
    &.qin-he {
      .content {
        border: 6px solid #db5951;
      }
      .desc {
        border-top: 2px solid #db5951;
        span {
          color: #db5951;
        }
      }
      .info {
        border-top: 2px solid #db5951;
        .user {
          .name {
            .name-line {
              border-top: 1px solid #eb7362;
            }
          }
        }
        .test-type {
          border-top: 2px solid #db5951;
          img {
            width: 214px;
            height: 94px;
          }
        }
        .test-desc {
          border-top: 2px solid #db5951;
          img {
            width: 262px;
          }
        }
        .totem {
          border: 2px solid #db5951;
        }
      }
      .test-content {
        border-top: 2px solid #db5951;
        .title {
          .title-line {
            border-top: 1px solid #db5951;
          }
        }
      }
      .test-hint {
        color: #db5951;
      }
      .course {
        background: #db5951;
      }
      .qr-code {
        border: 6px solid #db5951;
      }
    }
    &.wai-xian {
      .content {
        border: 6px solid #bda477;
      }
      .desc {
        border-top: 2px solid #bda477;
        span {
          color: #bda477;
        }
      }
      .info {
        border-top: 2px solid #bda477;
        .user {
          .name {
            .name-line {
              border-top: 1px solid #bda477;
            }
          }
        }
        .test-type {
          border-top: 2px solid #bda477;
          img {
            width: 184px;
            height: 86px;
          }
        }
        .test-desc {
          border-top: 2px solid #bda477;
          img {
            width: 260px;
          }
        }
        .totem {
          border: 2px solid #bda477;
        }
      }
      .test-content {
        border-top: 2px solid #bda477;
        .title {
          .title-line {
            border-top: 1px solid #bda477;
          }
        }
      }
      .test-hint {
        color: #bda477;
      }
      .course {
        background: #bda477;
      }
      .qr-code {
        border: 6px solid #bda477;
      }
    }
    &.zi-jue {
      .content {
        border: 6px solid #5588b4;
      }
      .desc {
        border-top: 2px solid #5588b4;
        span {
          color: #5588b4;
        }
      }
      .info {
        border-top: 2px solid #5588b4;
        .user {
          .name {
            .name-line {
              border-top: 1px solid #5588b4;
            }
          }
        }
        .test-type {
          border-top: 2px solid #5588b4;
          img {
            width: 268px;
            height: 86px;
          }
        }
        .test-desc {
          border-top: 2px solid #5588b4;
          img {
            width: 266px;
          }
        }
        .totem {
          border: 2px solid #5588b4;
        }
      }
      .test-content {
        border-top: 2px solid #5588b4;
        .title {
          .title-line {
            border-top: 1px solid #5588b4;
          }
        }
      }
      .test-hint {
        color: #5588b4;
      }
      .course {
        background: #5588b4;
      }
      .qr-code {
        border: 6px solid #5588b4;
      }
    }
    &.qin-xu {
      .content {
        border: 6px solid #030d5f;
      }
      .desc {
        border-top: 2px solid #030d5f;
        span {
          color: #030d5f;
        }
      }
      .info {
        border-top: 2px solid #030d5f;
        .user {
          .name {
            .name-line {
              border-top: 1px solid #030d5f;
            }
          }
        }
        .test-type {
          border-top: 2px solid #030d5f;
          img {
            width: 180px;
            height: 86px;
          }
        }
        .test-desc {
          border-top: 2px solid #030d5f;
          img {
            width: 262px;
          }
        }
        .totem {
          border: 2px solid #030d5f;
        }
      }
      .test-content {
        border-top: 2px solid #030d5f;
        .title {
          .title-line {
            border-top: 1px solid #030d5f;
          }
        }
      }
      .test-hint {
        color: #030d5f;
      }
      .course {
        background: #030d5f;
      }
      .qr-code {
        border: 6px solid #030d5f;
      }
    }
    &.kai-fang {
      .content {
        border: 6px solid #d43732;
      }
      .desc {
        border-top: 2px solid #d43732;
        span {
          color: #d43732;
        }
      }
      .info {
        border-top: 2px solid #d43732;
        .user {
          .name {
            .name-line {
              border-top: 1px solid #d43732;
            }
          }
        }
        .test-type {
          border-top: 2px solid #d43732;
          img {
            width: 158px;
            height: 92px;
          }
        }
        .test-desc {
          border-top: 2px solid #d43732;
          img {
            width: 266px;
          }
        }
        .totem {
          border: 2px solid #d43732;
        }
      }
      .test-content {
        border-top: 2px solid #d43732;
        .title {
          .title-line {
            border-top: 1px solid #d43732;
          }
        }
      }
      .test-hint {
        color: #d43732;
      }
      .course {
        background: #d43732;
      }
      .qr-code {
        border: 6px solid #d43732;
      }
    }
  }
  .result-container {
    /deep/ img {
      display: block;
      width: 100%;
    }
  }

  .content {
    border-radius: 10px;
  }
  .header {
    height: 94px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 184px;
      height: 60px;
      display: flex;
    }
  }
  .desc {
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @color-text-light;
    span {
      font-weight: @font-weight-bold;
      font-size: 32px;
    }
    .num {
      font-size: 40px;
    }
  }
  .info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .user-info {
      width: 334px;
    }
    .user {
      position: relative;
      height: 86px;
      display: flex;
      align-items: center;
      justify-content: center;
      .name {
        position: relative;
        margin-right: 6px;
        .name-line {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          content: '';
        }
      }
    }
    .test-type {
      padding-left: @size-medium;
      height: 138px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      img {
        display: block;
      }
    }
    .test-desc {
      padding-left: @size-medium;
      height: 168px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      span {
        font-weight: @font-weight-bold;
        color: @color-text-light;
        font-size: 30px;
      }
      img {
        margin-top: @size-small;
        display: block;
        height: 64px;
      }
    }
    .totem {
      margin: -2px -2px -2px 0;
      flex: 1;
      width: 350px;
      height: 396px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .test-content {
    padding: 50px 40px 30px 40px;
    font-size: 26px;
    .title {
      position: relative;
      display: inline-block;
      margin-bottom: 45px;
      padding-bottom: @size-extra-small;
      font-weight: @font-weight-bold;
      .title-line {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        content: '';
      }
    }
    .summary {
      line-height: 1.6;
    }
  }
  .test-hint {
    margin-bottom: 20px;
    padding: 0 @size-medium;
    font-weight: @font-weight-bold;
    font-size: 26px;
    line-height: 2;
  }
  .qr-code-block {
    display: flex;
    align-items: flex-end;
  }
  .save-hint {
    flex: 1;
    .hint {
      margin-bottom: @size-extra-small;
      padding: 0 @size-small 0 @size-base;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 22px;
      color: @color-text-light;
      line-height: 1;
    }
  }
  .course {
    height: 70px;
    font-size: @font-size-small;
    color: @color-white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .qr-code {
    margin: -6px;
    width: 150px;
    height: 150px;
    display: block;
    border-radius: 10px 0 10px 0;
  }

  .action-btn {
    width: 540px;
    height: 58px;
    img {
      margin: 0 auto;
    }
  }
</style>
